module.exports = __webpack_public_path__ + "static/media/66.45c65857.jpg";